import script from "./ManageAddress.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageAddress.vue?vue&type=script&setup=true&lang=js"

import "./ManageAddress.vue?vue&type=style&index=0&id=1b688048&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b688048"]])

export default __exports__